/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Switch from '@material-ui/core/Switch/Switch';
import {IRegisterForm} from 'packages/common-types/base-types';
import {useFormContext} from 'react-hook-form';
import {useState} from 'react';
import FormAddress from './FormAddress';
import FormClubInformation from './FormClubInformation';
import FormIdentity from './FormIdentity';
import FormPersonalInfo from './FormPersonalInfo';
import FormTitleSeparator from './FormTitleSeparator';

type Props = {
  /** Función que ejecuta el handleSubmit  */
  onSubmit: (credentials: IRegisterForm) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  submitting?: boolean;
};

const RegisterForm = ({onSubmit}: Props) => {
  const {handleSubmit} = useFormContext<IRegisterForm>();
  const [hasClub, setHasClub] = useState(false);
  const checkKeyDown = (e: any) => e.code === 'Enter' && e.preventDefault();

  return (
    <>
      <form
        id="create-account-form"
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={checkKeyDown}
        autoComplete="off"
      >
        <FormTitleSeparator
          title="Información de contácto"
          stepDesc="Paso 1: Escribe tu información de contacto"
        />
        <FormPersonalInfo />

        <FormTitleSeparator
          title="Identidad y Seguridad"
          stepDesc="Paso 2: Escribe la información de tus documentos y una contraseña
          segura"
        />
        <FormIdentity />

        <FormTitleSeparator
          title="Lugar de domicilio"
          stepDesc="Paso 3: Selecciona la ubicación en donde te encuentras"
        />
        <FormAddress />

        <FormControlLabel
          style={{paddingTop: 10, paddingBottom: 5}}
          control={
            <Switch
              checked={hasClub}
              onChange={() => setHasClub((prev) => !prev)}
              name="hasClubSwitch"
            />
          }
          label="Presiona si perteneces a algún club oficial de dominó."
        />
        {hasClub && <FormClubInformation />}
      </form>
    </>
  );
};

export default RegisterForm;
